import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../assets/images/courses-welcome.png'


const _withScopeId = n => (_pushScopeId("data-v-3ecc3c66"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dashboard-welcome remove-padding md:!tw-gap-4" }
const _hoisted_2 = { class: "dashboard-welcome__text" }
const _hoisted_3 = { class: "body-text" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dashboard-welcome__img md:!tw-w-full" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "img-wrapper" }, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "md:!tw-w-full",
      src: _imports_0,
      width: "364",
      height: "144"
    })
  ])
], -1))
const _hoisted_5 = { class: "courses__list all__courses" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "courses__title" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "All Courses")
], -1))
const _hoisted_7 = {
  key: 0,
  class: "courses__card__list !tw-px-2 tw-box-border"
}
const _hoisted_8 = { class: "tw-h-full" }
const _hoisted_9 = { class: "courses__card__img !tw-mb-[0]" }
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "courses__card__prefix !tw-justify-between tw-mt-4" }
const _hoisted_12 = { class: "left__prefix" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { class: "right__prefix" }
const _hoisted_16 = { class: "courses__text" }
const _hoisted_17 = { class: "courses__card__title !tw-leading-6 tw-mt-4" }
const _hoisted_18 = { class: "courses__card__subTitle tw-mt-2" }
const _hoisted_19 = { class: "tw-w-full tw-flex tw-flex-col tw-gap-2" }
const _hoisted_20 = {
  key: 1,
  class: "tw-flex tw-flex-col tw-justify-center tw-items-center tw-h-full tw-w-full tw-mt-[530px]"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_Loader = _resolveComponent("Loader")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h3", null, _toDisplayString(_ctx.title), 1),
        _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.text), 1)
      ]),
      _hoisted_4
    ]),
    _createElementVNode("div", _hoisted_5, [
      _hoisted_6,
      (!_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.coursesWithExtraInfo, (items) => {
              return (_openBlock(), _createBlock(_component_v_card, {
                class: "courses__card",
                key: items?.id
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("img", {
                        class: "",
                        cover: "",
                        src: require('@/assets/images/course/' + items?.thumbnail)
                      }, null, 8, _hoisted_10)
                    ]),
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("label", _hoisted_12, [
                        _createVNode(_component_v_icon, { icon: "mdi-currency-gbp" }),
                        (
                  items?.title ===
                  'Solar PV, Battery Storage & EV Charging Level 3'
                )
                          ? (_openBlock(), _createElementBlock("span", _hoisted_13, " £1,837.00"))
                          : (_openBlock(), _createElementBlock("span", _hoisted_14, " £1,558.00")),
                        _createTextVNode("FREE")
                      ]),
                      _createElementVNode("label", _hoisted_15, [
                        _createVNode(_component_v_icon, { icon: "mdi-map-marker" }),
                        _createTextVNode("Online & In-Person")
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("h5", _hoisted_17, _toDisplayString(items?.name), 1),
                      _createElementVNode("p", _hoisted_18, _toDisplayString(items?.about), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    (_ctx.isCurrentUserWorkstationOwner)
                      ? (_openBlock(), _createBlock(_component_v_btn, {
                          key: 0,
                          class: "button button-purple-border w-full !tw-mt-0",
                          onClick: ($event: any) => (_ctx.viewCourseDetails(items?.id))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("view full course details ")
                          ]),
                          _: 2
                        }, 1032, ["onClick"]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
            _createVNode(_component_Loader, { show: _ctx.loading }, null, 8, ["show"])
          ]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}